import { Input } from "antd";
import { SearchOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useState, useCallback } from "react";
import { debounce } from "lodash";

const SearchInput = ({ onSearch, placeholder }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = useCallback(
    debounce((value) => {
      onSearch(value);
    }, 1000),
    []
  );

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    handleSearch(value);
  };

  const handleClear = () => {
    setSearchTerm("");
    onSearch(""); // Call search with an empty string
  };

  return (
    <Input
      prefix={<SearchOutlined />}
      suffix={
        searchTerm && (
          <CloseCircleOutlined
            onClick={handleClear}
            style={{ cursor: "pointer", color: "#ccc" }}
          />
        )
      }
      variant="filled"
      style={{
        backgroundColor: "#fff",
        border: "none",
        boxShadow: "none",
        height: "40px",
      }}
      placeholder={placeholder}
      value={searchTerm}
      onChange={handleChange}
      onMouseEnter={(e) => (e.target.style.border = "none")}
      onMouseLeave={(e) => (e.target.style.border = "none")}
      onFocus={(e) => (e.target.style.border = "none")}
    />
  );
};

export default SearchInput;
